import GameModel from "../../../core/src/model/GameModel";
import GetGameRequest from "./GetGameRequest";
import VendorModel from "../../model/VendorModel";
import DebugModel from "../../../core/src/model/DebugModel";
import Utils from "../../../core/src/utils/Utils";

export default class GetBetResultRequest extends GetGameRequest {
  get requestData(): any {
    let userId = GameModel?.playerConfig?.userId || undefined;
    let debugData = DebugModel.debugData;
    
    if(typeof debugData  === "string") {
      try{
        debugData  = JSON.parse(debugData);
        debugData.generateSeed = true;
      } catch {
        throw(new Error("INVALID CUSTOM CHEAT ENTERED"));
      }
    }
    
    if (debugData && debugData.jackpot) {
      DebugModel.fakeJackpot = { name: debugData.jackpot, amount: debugData.amount };
      debugData = {};
    } else {
      DebugModel.cleanUp();
    }

    return {
      "action": "getBetResult",
      "gameId":  GameModel.apiConfig.gameId,
      "userId": userId,
      "authToken": GameModel.authToken,
      "currency": GameModel.currency,
      "casino": GameModel.casino,
      "sessionId": GameModel.sessionID,
      "playId": VendorModel.playId,
      "cheat":debugData || {},
      "data": {},
      'serverVersion': GameModel.apiConfig.serverVersion,
      'gameVersion': Utils.isNullOrWhiteSpace(GameModel.apiConfig.gameVersion) ? GameModel?.gameVersion : GameModel.apiConfig.gameVersion,
      'deviceInfo': Utils.getDeviceInfo(),
      "playerToken": GameModel.playerToken
    }
  }

}